document.addEventListener('DOMContentLoaded', () => {

  // 🚨 STOP IF DESKTOP
  if (window.matchMedia("(min-width: 769px)").matches) return;

  const modal = document.getElementById('storiesModal');
  if (!modal) return;

  const backdrop     = modal.querySelector('.stories-modal__backdrop');
  const video        = document.getElementById('storyVideo');
  const closeBtn     = document.getElementById('storyClose');
  const avatarEl     = document.getElementById('storyAvatar');
  const nameEl       = document.getElementById('storyName');
  const tapPrev      = document.getElementById('storyTapPrev');
  const tapNext      = document.getElementById('storyTapNext');
  const progressBars = modal.querySelectorAll('.stories-modal__progress-fill');

  const wrapper = document.querySelector('.video-stories-wrapper');
  if (!video || !wrapper) return;

  let storyList = [];
  let currentIdx = 0;

  function stopVideo() {
    video.pause();
    video.removeAttribute('src');
    video.load();
  }

  function resetBars() {
    progressBars.forEach(bar => {
      bar.style.transition = 'none';
      bar.style.width = '0%';
    });
  }

  function fillPreviousBars(index) {
    progressBars.forEach((bar, i) => {
      bar.style.transition = 'none';
      bar.style.width = i < index ? '100%' : '0%';
    });
  }

  function openStory(index) {
    if (index < 0 || index >= storyList.length) return;

    stopVideo(); // 🔥 prevent audio overlap

    const storyEl  = storyList[index];
    const videoUrl = storyEl.getAttribute('data-video-url');
    const name     = storyEl.getAttribute('data-name');
    const thumbImg = storyEl.querySelector('img');

    if (!videoUrl) return;

    currentIdx = index;

    avatarEl.src = thumbImg ? thumbImg.src : '';
    nameEl.textContent = name || '';

    fillPreviousBars(index);

    video.src = videoUrl;
    video.currentTime = 0;
    video.muted = true;

    modal.classList.add('is-active');
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    video.play().then(() => {
      video.muted = false;
    }).catch(() => {});
  }

  function closeStory() {
    modal.classList.remove('is-active');
    modal.style.display = 'none';

    stopVideo();
    document.body.style.overflow = '';
    resetBars();
  }

  function nextStory() {
    if (currentIdx + 1 < storyList.length) openStory(currentIdx + 1);
    else closeStory();
  }

  function prevStory() {
    if (currentIdx - 1 >= 0) openStory(currentIdx - 1);
  }

  video.addEventListener('timeupdate', () => {
    if (!video.duration) return;
    const pct = (video.currentTime / video.duration) * 100;
    if (progressBars[currentIdx]) {
      progressBars[currentIdx].style.width = pct + '%';
    }
  });

  video.addEventListener('ended', nextStory);

  tapPrev?.addEventListener('click', prevStory);
  tapNext?.addEventListener('click', nextStory);

  let touchStartX = 0;

  modal.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  modal.addEventListener('touchend', (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? nextStory() : prevStory();
  });

  // ✅ SCOPED CLICK (NO GLOBAL COLLISION)
  wrapper.addEventListener('click', (e) => {
    const storyEl = e.target.closest('.story');
    if (!storyEl) return;

    storyList = Array.from(wrapper.querySelectorAll('.story'));
    currentIdx = storyList.indexOf(storyEl);

    openStory(currentIdx);
  });

  closeBtn?.addEventListener('click', closeStory);
  backdrop?.addEventListener('click', closeStory);

});